import {useCallback} from 'react';

import {DataFrameNameState} from 'analysis-tool/data-frame-creation/DataFrameCreationTypes';
import {ConfigShapePath} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import {JSONValue} from 'util/Types';

/**
 * Bridges a step config's `dataFrameName` string field to the `DataFrameNameState` shape
 * expected by stepper form components (PlateSchemaStepperForm, RegistrySchemasStepperForm).
 */
export function useDataFrameNameStateBridge(
  config: Record<string, JSONValue>,
  onChangeConfig: (config: JSONValue, path: ConfigShapePath, newValue: JSONValue) => void
): {
  dataFrameNameState: DataFrameNameState;
  handleSetDataFrameNameState: (newState: DataFrameNameState) => void;
} {
  const name = (config.dataFrameName as string) ?? '';
  const dataFrameNameState: DataFrameNameState = {
    name,
    hasUserEdits: name !== '',
  };

  const handleSetDataFrameNameState = useCallback(
    (newState: DataFrameNameState) => {
      onChangeConfig(config, ['dataFrameName'], newState.name);
    },
    [config, onChangeConfig]
  );

  return {dataFrameNameState, handleSetDataFrameNameState};
}
